import "../../../styles/Home/Jumbotron/Jumbotron.css";
import anime from "animejs";
import { useEffect, useState } from "react";
import JumbotronImage from "../../../assets/mockups/jumbotron.png"

import { FormattedMessage, useIntl } from "react-intl";

import VectorStart from "../../../assets/vectors/vector-start.png"
import VectorEnd from "../../../assets/vectors/vector-end.png"
import Box from "../../../assets/misc/box.png"

const Jumbotron: React.FC = () => {
    useEffect(() => {
        anime.timeline({ loop: false })
            .add({
                targets: '#content',
                opacity: [0, 1],
                easing: 'easeInOutQuart',
                duration: 1000,
                offset: '-=500'
            })

        anime({
            targets: '.numbers-delayed',
            opacity: [0, 1], // From 0 to 1 to fade in
            delay: (el, i) => i * 500, // Delay based on index, so each element is delayed more
            easing: 'easeInOutSine',
            duration: 1000
        })
    }, []);

    const intl = useIntl()

    // check window size
    const [windowSize, setWindowSize] = useState<number>(window.innerWidth)

    window.addEventListener('resize', () => {
        setWindowSize(window.innerWidth)
    })

    return (
        <div className="container-fluid bg-jumbotron text-white sora position-relative z-2 pb-5">
            <div className="d-flex justify-content-center">
                <div className={`${windowSize >= 1024 && 'w-70'} bg-glass container-vertical-padding`}>
                    <span className="fw-bold" style={{fontSize: "58px"}}>Beralih dari Sheet pakai Sistem</span>
                    <div className="my-3 d-flex justify-content-center">
                        <h1
                            className="fw-bold border border-2 border-white text-black px-3 py-2 mt-3 position-relative"
                            style={{ backgroundColor: "#FFE660" }}>
                            #Wooblazz CRM
                            <img src={Box} alt="" className="position-absolute top-0 start-0 translate-middle" />
                            <img src={Box} alt="" className="position-absolute top-0 start-100 translate-middle" />
                            <img src={Box} alt="" className="position-absolute top-100 start-0 translate-middle" />
                            <img src={Box} alt="" className="position-absolute top-100 start-100 translate-middle" />
                        </h1>
                    </div>
                    <div className="d-flex justify-content-center">
                        <h4 className="mt-3" style={{width: "65%"}}>
                            Kelola dan monitoring segala aktivitas penjualan bisnis Anda dalam platform CRM yang paling simple & accessible.
                        </h4>
                    </div>
                </div>
            </div>
            <img src={JumbotronImage} alt="Wooblazz CRM" className="mt-5 pt-4 jumbotron-image rounded-4" width={"68%"} />
            <img src={VectorStart} alt="" className="img-fluid position-absolute bottom-0 start-0 z-n1" />
            <img src={VectorEnd} alt="" className="img-fluid position-absolute bottom-0 end-0 z-n1" />
        </div>
    )
}

export { Jumbotron }    